import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiMail, FiArrowLeft } from 'react-icons/fi';
import { toast } from 'react-toastify';
import { authAPI } from '../utils/api';
import './Auth.css';
import logo from './logo_efc.svg';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await authAPI.forgotPassword(email);
      setSent(true);
      toast.success(res.message || 'E-Mail versendet, falls das Konto existiert.');
    } catch (error) {
      // Auch bei Fehler generisch bleiben (kein User-Enumeration)
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="container">
        <div className="auth-form">
          <div className="auth-header">
            <img src={logo} alt="EFC Buseck" className="auth-logo" />
            <h2>Passwort vergessen?</h2>
            <p className="auth-subtitle">
              {sent
                ? 'Prüfe dein E-Mail-Postfach'
                : 'Gib deine E-Mail-Adresse ein – wir schicken dir einen Link zum Zurücksetzen.'}
            </p>
          </div>

          {sent ? (
            <div className="auth-success-box">
              <p>
                Falls ein Konto mit dieser E-Mail existiert, haben wir dir eine
                E-Mail mit einem Link zum Zurücksetzen deines Passworts geschickt.
              </p>
              <p className="auth-hint">Der Link ist 1 Stunde gültig. Schau auch im Spam-Ordner nach.</p>
              <Link to="/login" className="btn btn-primary auth-submit">Zurück zur Anmeldung</Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="email">E-Mail-Adresse</label>
                <div className="input-wrap">
                  <FiMail className="input-icon" aria-hidden="true" />
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    autoComplete="email"
                    placeholder="deine.email@beispiel.de"
                  />
                </div>
              </div>

              <button type="submit" className="btn btn-primary auth-submit" disabled={loading}>
                {loading ? 'Wird gesendet …' : 'Link anfordern'}
              </button>
            </form>
          )}

          <div className="auth-links">
            <p>
              <Link to="/login" className="auth-back">
                <FiArrowLeft aria-hidden="true" /> Zurück zur Anmeldung
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
